/**
 * Root Route Component
 *
 * Smart router component that handles the root path (/) behavior:
 * - Authenticated users: Redirect to /chat (core use case)
 * - Unauthenticated users: Show landing page
 * - Preserves query parameters during redirect
 * - Shows loading state during auth check
 */

import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import HomePage from '../pages/HomePage';

const RootRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Authenticated users: Redirect to /chat
  if (isAuthenticated) {
    // Preserve query parameters during redirect
    const queryString = searchParams.toString();
    const destination = queryString ? `/chat?${queryString}` : '/chat';

    return <Navigate to={destination} replace />;
  }

  // Unauthenticated users: Show landing page
  return <HomePage />;
};

export default RootRoute;
